import styled from 'styled-components'
import { FormattedMessage, useIntl } from 'react-intl'
import { useForm } from 'react-hook-form'
import { Button, Card, Input, Spinner, TextArea } from '../../atoms'
import { strings } from './ClosingEventForm.strings'

const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  gap: 1em;
  max-width: 600px;
  width: 100%;
  > p {
    color: ${({ theme }) => theme.colors.font.subdued};
  }
`
const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1em;
`

const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 12px;
  > p {
    margin: 0;
  }
`

interface ClosingEventData {
  closingHeader?: string
  closingMessage?: string
}

interface Props {
  initialData?: ClosingEventData
  onSubmit: (data: ClosingEventData) => void
  isLoading?: boolean
}

export const ClosingEventForm: React.FC<Props> = ({
  initialData,
  onSubmit,
  isLoading,
}) => {
  const intl = useIntl()
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ClosingEventData>({
    defaultValues: initialData,
  })

  return (
    <StyledCard>
      <Header>
        <h1>
          <FormattedMessage {...strings.header} />
        </h1>
        <p>
          <FormattedMessage {...strings.subheader} />
        </p>
      </Header>
      <Form onSubmit={handleSubmit(onSubmit)} data-testid="form">
        <Input
          label={intl.formatMessage(strings.headerLabel)}
          error={
            errors.closingHeader &&
            intl.formatMessage(strings.errorLabel, {
              field: intl.formatMessage(strings.headerName),
            })
          }
          {...register('closingHeader')}
          required
        />
        <TextArea
          label={intl.formatMessage(strings.messageLabel)}
          error={
            errors.closingMessage &&
            intl.formatMessage(strings.errorLabel, {
              field: intl.formatMessage(strings.messageName),
            })
          }
          {...register('closingMessage')}
        />
        <Button type="submit" disabled={isLoading}>
          {isLoading && <Spinner />}
          <FormattedMessage {...strings.submitButton} />
        </Button>
      </Form>
    </StyledCard>
  )
}
